import { render, staticRenderFns } from "./articlemanagehousedetail.vue?vue&type=template&id=07679dde&scoped=true&"
import script from "./articlemanagehousedetail.vue?vue&type=script&lang=js&"
export * from "./articlemanagehousedetail.vue?vue&type=script&lang=js&"
import style0 from "./articlemanagehousedetail.vue?vue&type=style&index=0&id=07679dde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07679dde",
  null
  
)

component.options.__file = "articlemanagehousedetail.vue"
export default component.exports